module.exports = __webpack_public_path__ + "img/6102c5c21407b0.96819994.07f60985.png";